import { captureException } from '@sentry/react'
import { useLocation } from 'react-router-dom'
import { OpenAPI } from 'src/services/openApiV2'
import { getModuleApiUrl } from 'src/services/openApiV2/utils/api.config'
import { getModuleRouteFromPathname } from 'src/utils/functions/moduleUtils'
import { usePrivateLayoutDrawerContext } from './PrivateLayoutDrawerContext'

export const ApiRouterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation()
  const { categorizedRoutes } = usePrivateLayoutDrawerContext()

  try {
    const currentModule = getModuleRouteFromPathname(location.pathname, categorizedRoutes)
    const moduleApiUrl = getModuleApiUrl(currentModule)

    // Only update if the URL has changed
    if (OpenAPI.BASE !== moduleApiUrl) {
      OpenAPI.BASE = moduleApiUrl
    }
  } catch (error) {
    console.error('[API Router] Failed to update API URL:', error)
    captureException(error)
  }

  return <>{children}</>
}
